<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table :headers="headers" :items="items" class="elevation-1" :loading="loading">
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.riskGrpNo }}</td>
                <td>{{ row.item.planDesc }}</td>
                <td>{{ row.item.noDay }}</td>
                <td>{{ row.item.noAdult }}</td>
                <td>{{ row.item.noChild }}</td>
                <td>{{ row.item.noLive }}</td>
                <td>{{ row.item.delRiskGrp }}</td>
                <td style="text-align: center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" color="primary" text @click.prevent="doSelect(row.item)">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ labels.query }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-spacer class="mt-3"></v-spacer>
    <!-- Subsidiary Details -->
    <v-expansion-panels>
      <v-expansion-panel v-if="showExpandRiskGrp">
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-format-align-justify</v-icon><span class="headerTitle">{{ labels.riskGrpDetail }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-flex xs12>
            <v-card>
              <!-- <v-toolbar dense color="grey lighten-5" flat>
                <v-icon>mdi-format-align-justify</v-icon>
                <v-toolbar-title class="toolbar-title-3">Risk Group Details</v-toolbar-title>
              </v-toolbar> -->
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex lg4 xs6>
                      <v-subheader class="queryLabel">{{ labels.riskGrpNo }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.riskGrpNo">{{ groupForm.riskGrpNo }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg4 xs6>
                      <v-subheader class="queryLabel">{{ labels.noDay }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.noDay || groupForm.noAdult !== undefined">{{ groupForm.noDay }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg4 xs6>
                      <v-subheader class="queryLabel">{{ labels.noAdult }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.noAdult || groupForm.noAdult !== undefined">{{ groupForm.noAdult }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg4 xs12>
                      <v-subheader class="queryLabel">{{ labels.planNo }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.planNo || groupForm.planNo !== undefined">{{ groupForm.planNo }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg4 xs12>
                      <v-subheader class="queryLabel">{{ labels.noChild }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.noChild || groupForm.noChild !== undefined">{{ groupForm.noChild }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg4 xs12>
                      <v-subheader class="queryLabel">{{ labels.noLive }}</v-subheader>
                      <span class="queryValue" v-if="groupForm.noLive || groupForm.noLive !== undefined">{{ groupForm.noLive }}</span>
                      <span class="queryValue" v-else>-</span>
                    </v-flex>
                    <v-flex lg8 xs12>
                      <v-textarea
                        v-model="groupForm.insdPremises"
                        :label="labels.insdPremises"
                        no-resize
                        rows="4"
                        :error-messages="errors.collect('insdPremises')"
                        data-vv-name="insdPremises"
                        :data-vv-as="labels.insdPremises"
                        :maxlength="200"
                        readonly
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel :disabled="!this.subsidiary">
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-nature-people</v-icon><span class="headerTitle">{{ labels.subTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Insured RefNo</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdRefNo">{{ groupForm.insdRefNo }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Name 1</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdName1">{{ groupForm.insdName1 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Name 2</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdName2">{{ groupForm.insdName2 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Block / House No.</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr1">{{ groupForm.insdAddr1 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Unit No.</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr2">{{ groupForm.insdAddr2 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Street Name</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr3">{{ groupForm.insdAddr3 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Building Name</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr4">{{ groupForm.insdAddr4 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">State</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr5">{{ groupForm.insdAddr5 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Country</v-subheader>
                    <span class="queryValue" v-if="groupForm.insdAddr6">{{ groupForm.insdAddr6 }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">Postal Code</v-subheader>
                    <div class="queryValue" v-if="groupForm.postCode">{{ groupForm.postCode }}</div>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Insured Persons -->
      <v-expansion-panel :disabled="!insdPerson">
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-account-multiple</v-icon><span class="headerTitle">{{ labels.insdPersonsTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table :headers="person.personHeaders" :items="person.personItems" class="elevation-1" :loading="person.loading">
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.seqNo }}</td>
                          <td>{{ row.item.insdName1 }}</td>
                          <td>{{ row.item.icNo }}</td>
                          <td>{{ row.item.dobFormat }}</td>
                          <td>{{ row.item.age }}</td>
                          <td style="text-align: center">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectPerson(row.item)">
                                  <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ labels.query }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.name }}</v-subheader>
                    <span class="queryValue" v-if="person.insdName1 || person.insdName2 || person.insdName3 || person.insdName4"
                      >{{ formatSalutation(person.titleName) }} {{ person.insdName1 }} {{ person.insdName2 }} {{ person.insdName3 }}
                      {{ person.insdName4 }}</span
                    >
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.icNo }}</v-subheader>
                    <span class="queryValue" v-if="person.icNo">{{ person.icNo }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.ageDob }}</v-subheader>
                    <span class="queryValue" v-if="person.age">{{ person.age }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                    <span class="queryValue" v-if="person.gender">{{ formatGender(person.gender) }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.mStat }}</v-subheader>
                    <span class="queryValue" v-if="person.mStat">{{ formatMaritalStatus(person.mStat) }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.occp }}</v-subheader>
                    <span class="queryValue" v-if="person.occp">{{ person.occp }} - {{ person.occpDesc }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.relation }}</v-subheader>
                    <span class="queryValue" v-if="person.relation">{{ person.relation }} - {{ person.relationDesc }}</span>
                    <span class="queryValue" v-else>-</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Risk Group Text -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-elevation-decline</v-icon><span class="headerTitle">{{ labels.riskGrpTxt }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-tabs v-model="riskGrpTxtTabMenu" slider-color="teal">
                      <v-tab ripple :key="1">{{ labels.upper }}</v-tab>
                      <v-tab ripple :key="2">{{ labels.lower }}</v-tab>
                      <v-tab ripple :key="3">{{ labels.memo }}</v-tab>
                      <v-tab ripple :key="4">{{ labels.standard }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="riskGrpTxtTabMenu">
                      <v-tab-item :key="1">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea v-model="groupForm.grpUppTxt" :rows="10" readonly></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item :key="2">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea v-model="groupForm.grpLwrTxt" :rows="10" readonly></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item :key="3">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea v-model="groupForm.grpMemo" :rows="10" readonly></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item :key="4">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea v-model="groupForm.grpStdTxt" :rows="10" readonly></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { formatYesNo } from '@/utils/boolean'
import { expandURI } from '@/utils/ajax'
import { toDate, parseISO } from 'date-fns'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { salutation, gender, maritalStatus } from '@/const/underwriting'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        subTitle: 'Subsidiary Details',
        sameInsdAddr: 'Same as Mailing Address',
        insdPersonsTitle: 'Insured Persons',
        riskGrpTxt: 'Risk Group Text',
        upper: 'Upper',
        lower: 'Lower',
        memo: 'Memo',
        standard: 'Standard',
        query: 'Query',
        name: 'Name',
        icNo: 'NRIC / FIN / Passport',
        ageDob: 'Age',
        gender: 'Gender',
        mStat: 'Marital Status',
        occp: 'Occupation',
        relation: 'Relationship to Main Insured',
        riskGrpNo: 'Risk Group',
        riskGrpDetail: 'Risk Group Detail',
        noDay: 'No. of Days',
        planNo: 'Plan No.',
        noAdult: 'No. of Adults',
        noChild: 'No. of Children',
        noLive: 'No. of Lives',
        insdPremises: 'Premises'
      },
      headers: [
        { text: 'Risk Group', align: 'left', value: 'riskGrpNo' },
        { text: 'Plan', align: 'left', value: 'plan' },
        { text: 'No. of Days', value: 'noDay' },
        { text: 'No. of Adults', value: 'noAdult' },
        { text: 'No. of Children', value: 'noChild' },
        { text: 'No. of Lives', value: 'noLive' },
        { text: 'Del Group', value: 'delRiskGrp' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      items: [],
      loading: false,
      showExpandRiskGrp: false,
      riskGrpTxtTabMenu: undefined,
      groupForm: {
        insdRefNo: undefined,
        insdName1: undefined,
        insdName2: undefined,
        insdAddr1: undefined,
        insdAddr2: undefined,
        insdAddr3: undefined,
        insdAddr4: undefined,
        insdAddr5: undefined,
        insdAddr6: undefined,
        postCode: undefined,
        sameAddr: undefined,
        grpUppTxt: undefined,
        grpLwrTxt: undefined,
        grpMemo: undefined,
        grpStdTxt: undefined,
        ctyDesc: undefined,
        riskGrpNo: undefined,
        delRiskGrp: undefined,
        noDay: undefined,
        planNo: '',
        noAdult: undefined,
        noChild: undefined,
        insdPremises: ''
      },
      person: {
        personHeaders: [
          { text: 'No.', align: 'left', value: 'seqNo' },
          { text: 'Name as in NRIC / Passport', value: 'insdName1' },
          { text: 'NRIC No.', value: 'icNo' },
          { text: 'Date of Birth', value: 'dob' },
          { text: 'Age', value: 'age' },
          { text: 'Action', align: 'center', sortable: false, value: '' }
        ],
        personItems: [],
        loading: false,
        titleName: undefined,
        insdName1: undefined,
        insdName2: undefined,
        insdName3: undefined,
        insdName4: undefined,
        icNo: undefined,
        dob: undefined,
        age: undefined,
        gender: undefined,
        mStat: undefined,
        occp: undefined,
        occpDesc: undefined,
        relation: undefined,
        relationDesc: undefined,
        insdPerson: true,
        subsidiary: true
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    doInit() {
      this.getPolicyRiskGroup()
    },
    async getPolicyRiskGroup() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.policyRiskGroup
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.displayDetails(result).then(() => {
            if (this.items.length > 0) {
              this.setSubsidiary(this.items[0])
              this.doSelect(this.items[0])
            }
            this.loading = false
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayDetails(result) {
      const { data } = result
      if (data) {
        this.insdPerson = data.insdPerson
        this.subsidiary = data.subsidiary
        this.items = []
        data.planList.map((plan) => {
          const convertPlan = {
            riskGrpNo: plan.riskGrpNo,
            planNo: plan.planNo,
            planDesc: plan.planDesc,
            noDay: plan.noDay,
            noAdult: plan.noAdult,
            noChild: plan.noChild,
            noLive: plan.noLive,
            insdPremises: plan.insdPremises,
            delRiskGrp: formatYesNo(plan.delRiskGrp),
            insdRefNo: plan.insdRefNo,
            titleName: plan.titleName,
            insdName1: plan.insdName1,
            insdName2: plan.insdName2,
            insdAddr1: plan.insdAddr1,
            insdAddr2: plan.insdAddr2,
            insdAddr3: plan.insdAddr3,
            insdAddr4: plan.insdAddr4,
            insdAddr5: plan.insdAddr5,
            insdAddr6: plan.insdAddr6,
            postCode: plan.postCode,
            grpUppTxt: plan.grpUppTxt,
            grpLwrTxt: plan.grpLwrTxt,
            grpMemo: plan.grpMemo,
            grpStdTxt: plan.grpStdTxt,
            ctyDesc: plan.ctyDesc
          }
          this.items.push(convertPlan)
        })
      } else {
        this.items = []
      }
    },
    setSubsidiary(data) {
      if (data) {
        this.groupForm.insdRefNo = data.insdRefNo
        this.groupForm.insdName1 = data.insdName1
        this.groupForm.insdName2 = data.insdName2
        this.groupForm.insdAddr1 = data.insdAddr1
        this.groupForm.insdAddr2 = data.insdAddr2
        this.groupForm.insdAddr3 = data.insdAddr3
        this.groupForm.insdAddr4 = data.insdAddr4
        this.groupForm.insdAddr5 = data.insdAddr5
        this.groupForm.insdAddr6 = data.insdAddr6
        this.groupForm.postCode = data.postCode
        this.groupForm.sameAddr = true
        this.groupForm.grpUppTxt = data.grpUppTxt
        this.groupForm.grpLwrTxt = data.grpLwrTxt
        this.groupForm.grpMemo = data.grpMemo
        this.groupForm.grpStdTxt = data.grpStdTxt
        this.groupForm.ctyDesc = data.ctyDesc

        this.getPolInsdDetList(data.riskGrpNo).then(() => {
          if (this.person.personItems.length > 0) {
            this.setPolInsdDet(this.person.personItems[0])
          }
        })
      }
    },
    doSelect(data) {
      this.groupForm.riskGrpNo = data.riskGrpNo
      this.groupForm.noDay = data.noDay
      this.groupForm.planNo = data.planNo
      this.groupForm.noAdult = data.noAdult
      this.groupForm.noChild = data.noChild
      this.groupForm.noLive = data.noLive
      this.groupForm.insdPremises = data.insdPremises
      this.showExpandRiskGrp = true
      this.setSubsidiary(data)
    },
    async getPolInsdDetList(grpNo) {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polInsdDetList
      if (apiUrl) {
        try {
          this.person.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: grpNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.person.personItems = []
            data.data.map((insdDet) => {
              const convertInsdDet = {
                riskGrpNo: insdDet.riskGrpNo,
                seqNo: insdDet.seqNo,
                insdRefNo: insdDet.insdRefNo,
                titleName: insdDet.titleName,
                insdName1: insdDet.insdName1,
                insdName2: insdDet.insdName2,
                insdName3: insdDet.insdName3,
                insdName4: insdDet.insdName4,
                icNo: insdDet.icNo,
                dob: insdDet.dob,
                dobFormat: this.formatDate(toDate(parseISO(insdDet.dob))),
                age: insdDet.age,
                gender: insdDet.gender,
                mStat: insdDet.mStat,
                occp: insdDet.occp,
                occpDesc: insdDet.occpDesc,
                relation: insdDet.relation,
                relationDesc: insdDet.relationDesc
              }
              this.person.personItems.push(convertInsdDet)
            })
            this.person.loading = false
          } else {
            this.person.personItems = []
            this.person.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    setPolInsdDet(data) {
      this.person.titleName = data.titleName
      this.person.insdName1 = data.insdName1
      this.person.insdName2 = data.insdName2
      this.person.insdName3 = data.insdName3
      this.person.insdName4 = data.insdName4
      this.person.icNo = data.icNo
      this.person.dob = data.dob
      this.person.age = data.age
      this.person.gender = data.gender
      this.person.mStat = data.mStat
      this.person.occp = data.occp
      this.person.occpDesc = data.occpDesc
      this.person.relation = data.relation
      this.person.relationDesc = data.relationDesc
    },
    doSelectPerson(data) {
      this.setPolInsdDet(data)
    },
    formatSalutation(data) {
      var salutation = this.salutationList.filter((salutation) => {
        return salutation.value === data
      })

      if (salutation.length > 0) {
        return salutation[0].label
      } else {
        return data
      }
    },
    formatGender(data) {
      var gender = this.genderList.filter((gender) => {
        return gender.value === data
      })

      if (gender.length > 0) {
        return gender[0].label
      } else {
        return data
      }
    },
    formatMaritalStatus(data) {
      var mStat = this.maritalStatusList.filter((mStat) => {
        return mStat.value === data
      })

      if (mStat.length > 0) {
        return mStat[0].label
      } else {
        return data
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
